import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, filter, map, switchMap, tap } from 'rxjs';
import { UserState } from 'src/app/auth/services/user-state.service';
import { ConsultFormService } from 'src/app/platform/modules/admin-portal/hospital/hospital/hospital-program/consult-form/consult-form.service';
import { NotificationService } from 'src/app/shared/layout/Toaster/NotificationService';
import { ModalService } from '../../services/modal.service';

@Component({
  selector: 'app-nav-bar',
  templateUrl: './nav-bar.component.html',
  styleUrls: ['./nav-bar.component.css']
})
export class NavBarComponent implements OnInit {

  currentUser$: Observable<any>;
  isNotifPopupOpened = false;
  isProfilePopupOpened = false;

  lastNotification$: Observable<any>;
  isNotifLoading = false;

  constructor(
    private userState: UserState,
    private router: Router,
    private consultFormSrv: ConsultFormService,
    private toasterService: NotificationService,
    public modalService: ModalService,
  ) {}

  ngOnInit(): void {
    this.currentUser$ = this.userState.currentUser$;
    this.lastNotification$ = this.currentUser$.pipe(
      filter( res => res != null),
      tap( x => this.isNotifLoading = true),
      switchMap(res => this.consultFormSrv.getNotificationDoc(res.id)),
      tap( x => this.isNotifLoading = false),
      map( (res:any) => res.notifications)
    );

  }

  logout() {
    this.toasterService.showInfo("Logging Out...", "" , {timeOut: 1000});

    this.userState.logout().subscribe((isLoggedOut : boolean) => {
      console.log(isLoggedOut);

    if(isLoggedOut) {
        this.toasterService.showSuccess("Logged Out", "");
        this.router.navigateByUrl('/auth/login');
    } else {
      this.toasterService.showError("Ops!", "Could not Logout");
    }
    });
  }


  onClickChangePassword() {
    this.modalService.openModal('changePasswordModal')
    this.isProfilePopupOpened = false;
  }

  closeModal() {
    this.modalService.closeModal('changePasswordModal')
  }
}
